import '@nimling/components-nimtech/dist/style.css'
import '@nimling/components-nimtech/dist/sam/style.css'
import 'uplot/dist/uPlot.min.css'
import './assets/main.css'

import App from './App.vue'
import GuestPagePage from './pages/GuestPagePage.vue'
import router from './router'

import { createApp, ref } from 'vue'
import { useTheme } from '@nimling/components-nimtech'
import { createPinia } from 'pinia'
import uPlot from 'uplot'
import * as echarts from 'echarts'
import { useMeStore } from '@/stores/me'
import { usePagesStore } from '@/stores/pages'
import { useThemesStore } from '@/stores/themes'
import { useSettingsStore } from '@/stores/settings'
import { useNotificationsStore } from '@/stores/notifications'
import { getViewCharts, putViewKit, setViewNavigate, setViewTableStore } from '@/lib/view'
import { getGuest, isGuest, setGuest } from '@/lib/api'

;(window as unknown as { uPlot: typeof uPlot }).uPlot = uPlot
;(window as unknown as { echarts: typeof echarts }).echarts = getViewCharts(echarts)

setViewNavigate((to) => (to.path.startsWith('/view/') || isGuest() ? window.location.assign(to.path) : void router.push(to.path)))
setViewTableStore({ get: (key) => useSettingsStore().getTableState(key), put: (key, state) => useSettingsStore().putTableState(key, state) })

const isAppReady = ref(false)

setGuest(router.resolve(window.location.pathname).name === 'page' && (await getGuest()))

const app = createApp(isGuest() ? GuestPagePage : App)

app.use(createPinia())
app.use(router)
putViewKit(app)

app.provide('isAppReady', isAppReady)

useTheme().init({ onChange: (theme) => useSettingsStore().putMeSettings({ appearance: { theme } }) })

app.mount('#app')

async function bootstrap() {
  try {
    const me = await useMeStore().getMe()
    if (!me) return
    const settings = await useSettingsStore().getMeSettings().catch(() => null)
    if (settings?.appearance?.theme && settings.appearance.theme !== useTheme().variant.value) useTheme().setTheme(settings.appearance.theme)
    await useThemesStore().putRootTheme().catch(() => null)
    isAppReady.value = true
    void useNotificationsStore().getNotificationList().catch(() => undefined)
    useNotificationsStore().connect()
    const pages = await usePagesStore().getPages().catch(() => null)
    if (pages && pages.length === 0 && !settings?.home) {
      await usePagesStore().postHomePage().catch(() => undefined)
      useSettingsStore().putMeSettings({ home: true })
    }
  } catch (error) {
    console.error('Failed to resolve the signed in user:', error)
  }
}

if (!isGuest()) bootstrap()
